import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-0 select-none text-[9rem] font-black leading-none text-foreground-100 md:text-[16rem]"
      >
        404
      </div>

      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-compass-3-line text-3xl"></i>
        </span>

        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t("notFoundTitle")}
        </h1>

        <p className="mt-3 max-w-md text-base leading-relaxed text-foreground-600">
          {t("notFoundDesc")}
        </p>

        <p className="mt-2 break-all text-sm text-foreground-400">{location.pathname}</p>

        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-home-4-line text-base"></i>
          </span>
          {t("notFoundCta")}
        </Link>
      </div>
    </div>
  );
}